<script lang="ts">
import {defineComponent, onMounted, ref} from 'vue';
import {useTranslationStore, translation} from '~/plugins/store/translations';
import {type MaintenanceResponse, type TranslationList} from "~/types/Utils";
import {useSystemStore} from "~/plugins/store/system";
import MasterLayout from "~/layouts/MasterLayout.vue";
import LoadingDialog from "~/components/utils/LoadingDialog.vue";
import {usePageStore} from "~/plugins/store/page";
import type {FaqQuestion, FaqCategory} from "~/types/Page";
export default defineComponent({
  setup() {
    useHead({
      title: 'XIGA | Intrebari frecvente',
    });

    const {$toast} = useNuxtApp();
    const translationStore = useTranslationStore();
    const translationList = ref<TranslationList>({});
    const systemStore = useSystemStore();
    const showLoadingDialog = ref(true);
    const messageLoadingDialog = ref('Se incarcă...');
    const faqTab = ref("0");
    const pageStore = usePageStore();
    const faqCategories = ref<FaqCategory[] | null>([]);
    const faqQuestions = ref<FaqQuestion[] | null>([]);

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      showLoadingDialog.value = true;
      messageLoadingDialog.value = translation(translationList.value.loading, 'Se incarcă...');

      faqCategories.value = await pageStore.getFaqCategories();

      faqQuestions.value = await pageStore.getQuestions();

      showLoadingDialog.value = false;
    });

    // Metoda de filtrare a întrebărilor pe baza categoriei curente
    const filteredQuestions = (categoryId: number) => {
      if (faqQuestions.value) {
        return faqQuestions.value.filter(q => q.category_id === categoryId);
      }
      return [];
    };

    return {
      translationList,
      translation,
      showLoadingDialog,
      messageLoadingDialog,
      faqTab,
      faqCategories,
      faqQuestions,
      filteredQuestions,
    };
  },
  components: {LoadingDialog, MasterLayout},
  data: () => ({}),
});
</script>

<template>
  <master-layout class="static">
    <v-container class="content-container">
      <v-container fluid class="component-container-1400mw">
        <v-container class="pa-0" style="max-width: 1200px; min-height: 500px;">
          <loading-dialog :message="messageLoadingDialog" :show-dialog="showLoadingDialog"/>
          <v-container class="component-container-800mw">
            <div class="d-flex flex-column align-center justify-center">
              <div class="fw-700 fs-30 text-center">
                {{ translation(translationList.faq_title, "Întrebări frecvente") }}
              </div>
            </div>
            <div class="mt-10">
              <v-tabs
                  class="faq-tab"
                  v-model="faqTab"
                  fixed-tabs
                  center-active
                  show-arrows
              >
                <v-tab variant="outlined" class="fw-600 text-dark" selected-class="selected" rounded="xl"
                       v-for="(faqCategory, index) in faqCategories" :key="index">
                  {{ faqCategory.category }}
                </v-tab>
              </v-tabs>

              <v-tabs-window v-model="faqTab">
                <v-tabs-window-item
                    v-for="(faqCategory, index) in faqCategories"
                    :key="index"
                    :value="index"
                >
                  <v-expansion-panels class="my-5 border-solid-contrast">
                    <v-expansion-panel
                        bg-color="gray-light"
                        rounded="xl"
                        v-for="(faqQuestion, qIndex) in filteredQuestions(<number>faqCategory.id)"
                        :key="qIndex"
                    >
                      <template v-slot:title>
                        <div class="fw-700 fs-20">{{ faqQuestion.question }}</div>
                      </template>
                      <template v-slot:text>
                        <div class="fw-500 fs-16 mx-4">
                          {{ faqQuestion.answer }}
                        </div>
                      </template>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-tabs-window-item>
              </v-tabs-window>
            </div>
          </v-container>
        </v-container>
      </v-container>
    </v-container>
  </master-layout>
</template>

<style scoped>

</style>
